import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import RichTextDisplayEditor from 'Components/ComponentLibrary/Components/Uncategorized/RichTextDisplayEditor';
import Typography from 'Components/UI/Typography';

const styles = theme => ({
  title: {
    margin: theme.spacing(1, 0),
  },
});

function TranscriptSummary({
  classes,
  content,
  handleSubmit,
}) {
  return (
    <>
      <Typography className={classes.title} color="primary" variant="h3">
        {'Summary'}
      </Typography>

      <RichTextDisplayEditor
        content={content}
        onSubmit={handleSubmit}
        placeholderLabel={'No call summary available, check back later'}
      />
    </>
  );
}

TranscriptSummary.propTypes = {
  classes: PropTypes.object.isRequired,
  content: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

TranscriptSummary.defaultProps = {};

export default withStyles(styles)(TranscriptSummary);
